import ApiService from '@/services/common/api.service';
import Utils from '@/helpers/utils';
import { Constants } from "@/helpers/constants";

const OCRManagementService = {
    listOCR,
};

/*
    List Group
*/
async function listOCR (search, page) {
    let url = '/ocr/search';

    let query = {};

    if (page) {
        query.page = page;
        query.pageSize = Constants.ItemPerpage;
    }

    if (search.branchId) {
        query.branchId = search.branchId;
    }

    if (search.departmentId) {
        query.departmentId = search.departmentId;
    }

    if (search.groupId) {
        query.groupId = search.groupId;
    }

    if (Utils.isEmptyObj(query) == false) {
        let httpBuildQuery = require('http-build-query');
        url += "?" + httpBuildQuery(query);
    }

    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

export default OCRManagementService;



// WEBPACK FOOTER //
// ./src/services/admin/ocr.service.js